// Version : 1.0.0
// Author : AGALYA

const AadharDetailsActionType = {
	/** ***************** AADHAR FRONT AND BACK IMAGE CHANGED *********************** */
	AADHAR_FRONT_IMAGE_CHANGED: 'aadhar_front_image_changed',
	AADHAR_BACK_IMAGE_CHANGED: 'aadhar_back_image_changed',

	/** ***************** UPDATE AADHAR START*********************** */
	UPDATE_AADHAR_START: 'update_aadhar_start',
	UPDATE_AADHAR_SUCCESS: 'update_aadhar_success',
	UPDATE_AADHAR_FAILURE: 'update_aadhar_failure',
	UPDATE_AADHAR_RESPONSE_REST_START: 'update_aadhar_response_reset_start',
	UPDATE_AADHAR_RESPONSE_CHANGED: 'update_aadhar_response_changed',
	/** ***************** UPDATE AADHAR END*********************** */

	/** ***************** SEND OTP START *********************** */
	SEND_AADHAR_OTP_START: 'send_otp_start',
	SEND_AADHAR_OTP_SUCCESS: 'send_otp_success',
	SEND_AADHAR_OTP_FAILURE: 'send_otp_failure',
	SEND_AADHAR_OTP_RESPONSE_RESET: 'send_otp_response_reset',
	SEND_AADHAR_OTP_RESPONSE_CHANGED: 'send_otp_response_changed',
	/** ***************** SEND OTP END *********************** */
};

export default AadharDetailsActionType;
